import React, { useState } from "react";
import {
  HtmlEditor,
  Image,
  Inject,
  Link,
  QuickToolbar,
  RichTextEditorComponent,
  Toolbar,
} from "@syncfusion/ej2-react-richtexteditor";
import axios from "axios";
import { Header } from "../components";
import { baseUrl } from "../data/baseURL";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

const Editor = () => {
  const { state } = useLocation();
  const [landingImage, setLandingImage] = useState(state?.landingImage ? state.landingImage : null);
  const [content, setContent] = useState(state?.content ? state.content : "");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setLandingImage(file); // Store the file directly
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = async () => {
    if (!content || !landingImage) {
      window.alert("عکس و توضیحات اجباری می‌باشد");
      return null;
    }
    const token = localStorage.getItem("token");
    const publishDate = Math.floor(Date.now() / 1000);
    setLoading(true);

    const formData = new FormData();
    formData.append("Content", content);
    formData.append("PublishDate", publishDate);
    formData.append("LandingImage", landingImage);

    try {
      const response = await axios.post(`${baseUrl}/Article`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setLoading(false);
      navigate("/pics");
    } catch (error) {
      console.error("Error submitting post:", error);
      setLoading(false);
    }
  };

  const handleEdit = async (data) => {
    if (!content) {
      window.alert("توضیحات اجباری می‌باشد");
      return null;
    }
    setLoading(true);
    const token = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("Id", state.id);
    formData.append("Content", content);
    formData.append("LandingImage", landingImage);

    try {
      await axios.put(`${baseUrl}/Article`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setLoading(false);
      navigate("/pics");
    } catch (error) {
      console.error("Error editing post:", error);
      setLoading(false);
    }
  };

  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <Header category="App" title={state ? "ویرایش عکس " + state.id : "ایجاد عکس"} />

      { state &&
        <img
        src={ baseUrl + "/assets/" + state.landingImage}
        style={{
          maxHeight: "50px",
          marginBottom: "20px"
        }}
      />
      }

      <div className="mb-4">
        <input type="file" accept="image/*" onChange={handleImageUpload} required/>
      </div>

      <div className="mb-4">
        <textarea
          style={{
            width: "100%",
            border: "1px solid #ccc",
            height: "150px",
            borderRadius: "15px",
            padding: "10px",
            resize: "none"
          }}
          placeholder="توضیحات عکس"
          maxLength={300}
          onChange={(e) => {
            setContent(e.target.value)
          }}
        >
          {content}
        </textarea>
      </div>

      <button
        className="bg-blue-500 text-white p-2 rounded"
        onClick={state ? handleEdit : handleSubmit}
        disabled={loading}
      >
        {loading ? "در حال ارسال..." : (state ? "ویرایش عکس" : "ارسال عکس")}
      </button>
    </div>
  );
};

export default Editor;
